export const inspectTable = [
  {
    title: "1. 도급, 용역, 위탁 시 산업재해 예방 조치능력 평가",
    content: "입찰 공고문, 과업지시서, 계약서, 위탁협약서 등에 안전·보건 확보 의무사항 명시",
    isChecked: "",
  },
  {
    title: "1. 도급, 용역, 위탁 시 산업재해 예방 조치능력 평가",
    content: "‘협상의 의한 계약 제안서’ 평가 시 안전·보건 확보 관련 내용 포함",
    isChecked: "",
  },
  {
    title: "1. 도급, 용역, 위탁 시 산업재해 예방 조치능력 평가",
    content: "안전보건 확보 의무이행 서약서 징구(안전보건관리계획서)",
    isChecked: "",
  },
  {
    title: "2. 도급, 용역, 위탁 시 종사자 안전·보건을 위한 관리비용 반영",
    content: "종사자 안전·보건 확보를 위한 관련비용 반영(안전관리비, 산업안전보건관리비 등)",
    isChecked: "",
  },
  {
    title: "3. 안전·보건 수준 평가",
    content: "적격 수급업체 선정 가이드라인",
    isChecked: "",
  },
  {
    title: "4. 안전보건협의체 구성 및 운영",
    content: "안전보건협의체 구성 및 운영(월 1회)",
    isChecked: "",
  },
  {
    title: "5. 작업장 순회 점검",
    content: "작업장 순회 점검(주 1회 이상)",
    isChecked: "",
  },
  {
    title: "6. 사업장 합동 안전·보건 점검",
    content: "사업장 합동 안전·보건 점검 실시(분기별 1회 이상)",
    isChecked: "",
  },
  {
    title: "7. 위험성 평가 및 유해·위험요인 개선",
    content: "위험성 평가 및 유해·위험요인 개선 조치 여부",
    isChecked: "",
  },
  {
    title: "8.  안전·보건교육 지원 및 실시 여부 확인",
    content: "안전·보건교육 장소 및 자료 제공 등 협조(수급인의 요구가 있는 경우)",
    isChecked: "",
  },
  {
    title: "8.  안전·보건교육 지원 및 실시 여부 확인",
    content: "수급인의 특별안전보건교육 실시 여부 확인(특별안전보건교육 대상 있는 경우)",
    isChecked: "",
  },
  {
    title: "9. 경보체계 운영과 대피방법 등 훈련",
    content: "경보체계 운영과 대피방법 등 훈련 여부(발파작업, 화재·폭발, 붕괴 등의 경우)",
    isChecked: "",
  },
  {
    title: "10. 위생(휴게)시설 및 휴게시설 설치 및 이용",
    content: "위생(휴게)시설 및 휴게시설 설치 및 이용 협조 여부",
    isChecked: "",
  },
  {
    title: "11. 같은 장소 내 도급인과 관계수급인 등 작업시기·내용 등 조정",
    content: "관계 수급인 작업시기·내용 등 조정(같은 장소에서 도급인과 수급인의 작업이 혼재하여 위험 발생할 우려가 있는 경우)",
    isChecked: "",
  },
  {
    title: "12. 안전·보건에 관한 정보 제공 등",
    content: "안전 및 보건에 관한 정보제공 및 이행 확인(화학물질, 질식, 붕괴 위험의 경우)",
    isChecked: "",
  },
];
